import type { FiltersContext } from '@openx/components-filters/lib/context/types';
import { FILTER_TYPES } from '@openx/components-filters/lib/FiltersBar/types';
import { AdFormat, BidderCreativeStatus } from '@openx/types/gqlTypes';
import type { TFunction } from 'i18next';
import type { CreativesListFilters } from './types';

export const getFiltersConfig = (t: TFunction): FiltersContext<CreativesListFilters>['filtersConfig'] => [
  {
    key: 'status',
    name: t('Status'),
    type: FILTER_TYPES.RADIO,
    options: [
      { id: BidderCreativeStatus.Active, name: t('Active') },
      { id: BidderCreativeStatus.Paused, name: t('Paused') },
    ],
  },
  {
    key: 'ad_format',
    name: t('Ad Format'),
    type: FILTER_TYPES.RADIO,
    options: [
      { id: AdFormat.Banner, name: t('Banner') },
      { id: AdFormat.Video, name: t('Video') },
    ],
  },
];
